var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188,
    height: 14,
    viewBox: "0 0 188 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(94 9)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "IRANSans-Bold, IRAN Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -93.865,
    y: 0
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "\u062A\u0647\u0631\u0627\u0646\u060C \u062E\u06CC\u0627\u0628\u0627\u0646 \u0634\u0631\u06CC\u0639\u062A\u06CC\u060C \u067E\u0627\u06CC\u06CC\u0646 \u062A\u0631 \u0627\u0632 \u0645\u0644\u06A9\u060C \u06A9\u0648\u0686\u0647 \u0634\u06A9\u0648\u0631\u06CC\u060C \u067E\u0644\u0627\u06A9"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.c3def7ac524a5fd4ba754509379e3a57.svg";
export { ForwardRef as ReactComponent };